 // Créer un objet pour la traduction
export const difficultyTranslation = {
    easy: "Facile",
    medium: "Moyenne",
    hard: "Difficile",
  };